import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("operator-console: #root element not found in index.html");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
